// extracted by mini-css-extract-plugin
export var container = "SocialShareFull-module--container--eb5ec";
export var heading = "SocialShareFull-module--heading--b9843";
export var iconsContainer = "SocialShareFull-module--icons-container--abb7d";
export var networkContainer = "SocialShareFull-module--network-container--6dcdd";
export var yumButton = "SocialShareFull-module--yum-button--2c205";